"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});


var list = function () {
  // It's convenient to be able to reference earlier achievements when defining
  // later achievements, so we'll jump through a few hoops to make that possible
  // instead of defining this as a simple inline list. Could postprocess in a
  // selector instead, and/or normalize quotas separately from their
  // achievements, but this works fine for now.
  var ret = [];
  var byName = {};
  var push = function push(val) {
    ret.push(val);
    byName[val.name] = val;
  };
  push({
    name: "named",
    points: 10,
    visible: {},
    complete: { "character.named": true }
  });
  push({
    name: "drone1",
    points: 10,
    visible: {},
    complete: { "units.bought.drone": "1" }
  });
  push({
    name: "drone2",
    points: 20,
    visible: byName.drone1.complete,
    complete: { "units.bought.drone": "201" }
  });
  push({
    name: "drone3",
    points: 30,
    visible: byName.drone2.complete,
    complete: { "units.bought.drone": "10000" }
  });
  push({
    name: "hatchery1",
    points: 10,
    visible: {},
    complete: { "units.looted.hatchery": "1" }
  });
  push({
    name: "hatchery2",
    points: 20,
    visible: byName.hatchery1.complete,
    complete: { "units.looted.hatchery": "300" }
  });
  push({
    name: "hatchery3",
    points: 30,
    visible: byName.hatchery2.complete,
    complete: { "units.looted.hatchery": "3000" }
  });
  push({
    name: "zones1",
    points: 10,
    visible: {},
    complete: { "zones.cleared": 1 }
  });
  push({
    name: "zones2",
    points: 20,
    visible: byName.zones1.complete,
    complete: { "zones.cleared": 5 }
  });
  return ret;
}();

// TODO: groups. Similar to D3's season journey, or achievement categories

exports.default = { list: list, schema: null };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/entities2/achievement-types/data.js
// module id = 796
// module chunks = 0